export default {
  props: {
    length: {
      type: Number,
      required: false,
      default: 4,
    },
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      values: new Array(this.length),
      focusIndex: 0,
      nextFocusIndex: 0,
    };
  },
  methods: {
    getFocusIndex(domElement) {
      for (let i = 1; i <= this.length; i++) {
        const ref = this.$refs[`input${i}`];

        if (ref[0] === domElement) {
          return i;
        }
      }

      return 1;
    },
    select(pointerEvent) {
      this.focusIndex = this.getFocusIndex(pointerEvent.target);
      pointerEvent.target.select();
    },
    onKeyUp(keyUpEvent) {
      // focus next, input has been cleared by backspace
      let focusIndex = this.nextFocusIndex;

      if (keyUpEvent.key === "Backspace") {
        focusIndex--;
      }

      if (focusIndex < this.numDigits) {
        focusIndex = this.numDigits;
      }

      if (focusIndex > this.numDigits + 1) {
        focusIndex = this.numDigits;
      }

      this.focusIndex = focusIndex;
    },
    updateValues() {
      const allChars = this.values.join("");
      let numDigits = 0;
      this.values = new Array(this.length);

      for (let i = 0; i < allChars.length && numDigits < this.length; i++) {
        const parsed = parseInt(allChars[i]);

        if (!isNaN(parsed)) {
          this.$set(this.values, numDigits, parsed);
          numDigits += 1;
        }
      }

      if (numDigits > this.length) {
        numDigits = this.length;
      }

      this.nextFocusIndex = numDigits + 1;
      this.numDigits = numDigits;
      this.$emit("input", parseInt(this.values.join("")));
    },
  },
  watch: {
    focusIndex(newVal, oldVal) {
      if (newVal > this.length) {
        this.focusIndex = this.length;
        return;
      }

      if (newVal < 1) {
        this.focusIndex = 1;
        return;
      }

      this.nextFocusIndex = newVal;
      this.$refs[`input${this.focusIndex}`][0].select();
    },
  },
};
